import { IconSvg } from './IconSvg';

export function Maestro() {
    return (
        <IconSvg>
            <path fill="#7673C0" d="M23.64 3.287h-7.305V16.41h7.306" />
            <path
                d="M16.8 9.848c0-2.55 1.183-4.985 3.2-6.56C16.384.435 11.12 1.06 8.29 4.7 5.435 8.32 6.06 13.58 9.703 16.41c3.038 2.387 7.283 2.387 10.32 0-2.04-1.578-3.223-3.99-3.223-6.562z"
                fill="#EB001B"
            />
            <path
                d="M33.5 9.848c0 4.613-3.735 8.346-8.35 8.346-1.88 0-3.69-.626-5.15-1.785 3.618-2.83 4.245-8.092 1.415-11.71-.418-.532-.882-.996-1.415-1.413C23.618.437 28.883 1.06 31.736 4.7 32.873 6.163 33.5 7.994 33.5 9.85z"
                fill="#00A1DF"
            />
        </IconSvg>
    );
}
